var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatedByFairo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#2352C1",
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5.62046C6 5.27779 6.2837 5 6.63366 5H12.2979C13.2379 5 14 5.74619 14 6.66667C14 7.58714 13.2379 8.33333 12.2979 8.33333H6.63366C6.2837 8.33333 6 8.05554 6 7.71287V5.62046ZM6.46514 15C6.20825 15 6 14.7961 6 14.5446V10.9167C6 9.99619 6.76207 9.25 7.70213 9.25C8.64219 9.25 9.40426 9.99619 9.40426 10.9167V14.5446C9.40426 14.7961 9.19601 15 8.93912 15H6.46514ZM10.3436 10.5077C10.2107 10.5673 10.2124 10.7529 10.3464 10.8103L12.1974 11.6031C12.9071 11.9071 13.7021 11.3979 13.7021 10.6394C13.7021 9.8729 12.8918 9.36378 12.1802 9.68322L10.3436 10.5077Z",
    fill: "white",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedByFairo);
export default __webpack_public_path__ + "static/media/created-by-fairo.4aac985ca3bb1b51ef0d8e6dc80efca0.svg";
export { ForwardRef as ReactComponent };